import Main from '../../types/enums/main';
import promoRequest from './addonPromoRequest';
import { Observable } from 'rxjs';

const WAITING_TIME = 100;

function addonPromoObservable(id: string) {
  return new Observable((subscriber) => {
    promoRequest(id).then((data) => {
      setTimeout(() => {
        subscriber.next({ type: Main.SLIDERS, data });
        subscriber.complete();
      }, WAITING_TIME);
    });
  });
}

export default addonPromoObservable;
